const noop = () => undefined;
export { noop as n };